import { useEffect } from "react";

export default function ScrollToRootOnLoad() {
	useEffect(() => {
		const rootDiv = document.getElementById("appsuite-root");
		if (rootDiv) {
			rootDiv.scrollIntoView({ behavior: "smooth" });
		}
	}, []);

	return null; // This component just performs the scroll effect
}
